import { Language } from '@coolblue-development/constants';
export function getLocale(language, subsidiary) {
    if (language === Language.ENGLISH) {
        return 'en-US';
    }
    return `${language}-${subsidiary.toUpperCase()}`;
}
export function convertDatePartsToObject(parts) {
    return parts.reduce((acc, part) => {
        const { type, value } = part;
        if (type === 'literal') {
            return acc;
        }
        return { ...acc, [type]: value };
    }, {});
}
export function isToday(date) {
    const now = new Date();
    return (date.getDate() === now.getDate() &&
        date.getMonth() === now.getMonth() &&
        date.getFullYear() === now.getFullYear());
}
export function isTomorrow(date) {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    return (date.getDate() === tomorrow.getDate() &&
        date.getMonth() === tomorrow.getMonth() &&
        date.getFullYear() === tomorrow.getFullYear());
}
export function isYesterday(date) {
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    return (date.getDate() === yesterday.getDate() &&
        date.getMonth() === yesterday.getMonth() &&
        date.getFullYear() === yesterday.getFullYear());
}
export function getWeekNumber(date = new Date()) {
    const localDate = new Date(date.getTime());
    localDate.setDate(localDate.getDate() + 4 - (localDate.getDay() || 7));
    const thursday = localDate.getTime();
    // Find January 1st
    localDate.setMonth(0); // January
    localDate.setDate(1); // 1st
    const jan1st = localDate.getTime();
    // Round the amount of days to compensate for daylight saving time
    const oneDayInMilliseconds = 86400000;
    const days = Math.round((thursday - jan1st) / oneDayInMilliseconds);
    return Math.floor(days / 7) + 1;
}
export function isThisWeek(date) {
    return getWeekNumber() === getWeekNumber(date);
}
export function isNextWeek(date) {
    const nextWeek = new Date();
    nextWeek.setDate(nextWeek.getDate() + 7);
    const weekNumber = getWeekNumber(nextWeek);
    return weekNumber === getWeekNumber(date);
}
export function isLastWeek(date) {
    const nextWeek = new Date();
    nextWeek.setDate(nextWeek.getDate() - 7);
    const weekNumber = getWeekNumber(nextWeek);
    return weekNumber === getWeekNumber(date);
}
export function isThisMonth(date) {
    const now = new Date();
    return date.getMonth() === now.getMonth();
}
export function isNextMonth(date) {
    const nextMonth = new Date();
    nextMonth.setMonth(nextMonth.getMonth() + 1);
    return date.getMonth() === nextMonth.getMonth();
}
export function isThisYear(date) {
    const now = new Date();
    return date.getFullYear() === now.getFullYear();
}
export function isNextYear(date) {
    const nextYear = new Date();
    nextYear.setFullYear(nextYear.getFullYear() + 1);
    return date.getFullYear() === nextYear.getFullYear();
}
export function addDays(date, days) {
    const result = new Date(date);
    result.setDate(date.getDate() + days);
    return result;
}
//# sourceMappingURL=helpers.js.map